// src/hooks/NovuProvider.tsx
import { Novu } from "@novu/js";
import { createContext, useContext, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
var version = "3.4.0";
var name = "@novu/react";
var baseUserAgent = `${name}@${version}`;
var NovuContext = createContext(void 0);
var NovuProvider = ({
  children,
  applicationIdentifier,
  subscriberId,
  subscriberHash,
  backendUrl,
  apiUrl,
  socketUrl,
  useCache,
  subscriber
}) => {
  return /* @__PURE__ */ jsx(
    InternalNovuProvider,
    {
      applicationIdentifier,
      subscriberHash,
      backendUrl,
      apiUrl,
      socketUrl,
      useCache,
      userAgentType: "hooks",
      subscriber: buildSubscriber(subscriberId, subscriber),
      children
    }
  );
};
var InternalNovuProvider = ({
  children,
  applicationIdentifier,
  subscriberId,
  subscriberHash,
  backendUrl,
  apiUrl,
  socketUrl,
  useCache,
  subscriber,
  userAgentType
}) => {
  const novu = useMemo(
    () => new Novu({
      applicationIdentifier,
      subscriberHash,
      backendUrl,
      apiUrl,
      socketUrl,
      useCache,
      __userAgent: `${baseUserAgent} ${userAgentType}`,
      ...subscriber ? { subscriber } : { subscriberId }
    }),
    [
      applicationIdentifier,
      subscriberId,
      subscriberHash,
      backendUrl,
      apiUrl,
      socketUrl,
      useCache,
      subscriber,
      userAgentType
    ]
  );
  return /* @__PURE__ */ jsx(NovuContext.Provider, { value: novu, children });
};
var useNovu = () => {
  const context = useContext(NovuContext);
  if (!context) {
    throw new Error("useNovu must be used within a <NovuProvider />");
  }
  return context;
};
var useUnsafeNovu = () => {
  const context = useContext(NovuContext);
  return context;
};
function buildSubscriber(subscriberId, subscriber) {
  let subscriberObj;
  if (subscriber) {
    subscriberObj = typeof subscriber === "string" ? { subscriberId: subscriber } : subscriber;
  } else {
    subscriberObj = { subscriberId };
  }
  return subscriberObj;
}
export {
  InternalNovuProvider,
  NovuProvider,
  useNovu,
  useUnsafeNovu
};
//# sourceMappingURL=NovuProvider.js.map